<template>
  <vs-button v-if="iconPack === 'useral'"
             type="filled"
             class="table-cell-action-button useral m-auto"
             style="padding: 0.2rem !important;"
             :color="color ? color : 'primary'"
             @click="buttonClicked">
    <custom-icon :icon="icon" height="2rem" width="2rem" color-code="#ffffff" />
  </vs-button>

  <vs-button v-else-if="showActions"
             class="table-cell-action-button m-auto"
             :class="{'has-text': text}"
             type="filled"
             :icon="icon ? icon : ''"
             :icon-pack="iconPack ? iconPack : ''"
             :color="color ? color : 'primary'"
             @click="buttonClicked">
    <span v-if="text">{{ text }}</span>
  </vs-button>

  <vs-button v-else-if="text"
             class="table-cell-action-button has-text m-auto"
             :class="{'has-text': text}"
             type="filled"
             :color="color ? color : 'primary'"
             @click="buttonClicked">
    <span>{{ text }}</span>
  </vs-button>
</template>

<script>
import CustomIcon from '../../icon/customIcon.vue'
export default {
  name: 'actionsBox',
  components: {CustomIcon},
  props: {
    show: {
      type: [String, Boolean],
      default: ''
    },
    lookField: {
      type: [String, Boolean],
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconPack: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      lookFields: [],
      firstValue: {},
      showActions: false
    }
  },
  created () {
    if (typeof this.lookField === 'string') {
      this.lookFields = [this.lookField]
    } else if (Array.isArray(this.lookField)) {
      this.lookFields = this.lookField
    }

    switch (this.show) {
    case 'always':
    case 'hideAfterClick':
      this.showActions = true
      break

    case 'onchange':
      this.lookFields.forEach((field) => {
        this.firstValue[field] = this.data[field]
      })
      break
    }
  },
  methods: {
    buttonClicked (event) {
      event.stopPropagation()
      event.preventDefault()
      setTimeout(() => {

        switch (this.type) {
        case 'reset_input':
          this.lookFields.forEach((field) => {
            this.firstValue[field] = this.data[field]
          })
          this.showActions = false
          break

        case 'button':
          break

        case 'hideAfterClick':
          this.showActions = false
          break

        default:
          this.lookFields.forEach((field) => {
            this.firstValue[field] = this.data[field]
          })
          this.showActions = false
          break
        }

        this.$emit('clicked')
      }, 500)
    }
  },
  watch: {
    data: {
      handler (val) {
        let checkStatus = 0

        switch (this.show) {
        case 'hideAfterClick':
          break

        case 'always':
          this.showActions = true
          break

        case 'onchange':
          this.lookFields.forEach((field) => {
            if (val[field] !== this.firstValue[field]) {
              checkStatus++
            }
          })

          this.showActions = checkStatus > 0
          break
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.table-cell-action-button {
  width: 3rem !important;
  height: 3rem !important;
  padding: 0 !important;
  border-radius: 0.6rem;

  &.has-text {
    flex: 1;
    font-weight: 700 !important;
    min-width: fit-content;
    padding: 0 0.5rem !important;
  }

  &.useral {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:deep(.vs-icon) {
    font-size: 1.8rem;
  }
}
</style>
